import { AbstractFacade } from '@goparrot/common';
import deepmerge from 'deepmerge';
export class AuthV2Facade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_GATEWAY,
                },
            },
            config,
        ]), interceptors);
    }
    async login(data) {
        return (await this.client.post(`/api/v2/auth/login`, data)).data;
    }
    async refreshToken() {
        return (await this.client.post(`/api/v2/auth/token`)).data;
    }
}
//# sourceMappingURL=AuthV2Facade.js.map